<template>
<b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
        <b-col cols="3">
          <Menu></Menu>
        </b-col>
        <b-col cols="9" class="border">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" class="head">
                  <h4>:: Versión</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="breadcrumb">
                  <b-link :href="/models-by-brand/">Modelos por Marca</b-link> &raquo; <b-link :href="'/models-by-brand/model/'+ version.slug_brand">Lista de Modelos de {{ version.brand }}</b-link> &raquo; {{version.name}}:
                </b-col>
              </b-row>
              <div class="mt-2"></div>
              <div class="pb-2 cliente-detalle mb-4">
                    <b-row>
                      <b-col cols="12" class="text-left pr-4 pl-4">
                        <label>Nombre:</label> <strong>{{version.name}}</strong><br>
                        <label>Marca:</label> <strong>{{version.brand}}</strong><br>
                        <label>Slug de la Marca:</label> <strong>{{version.slug_brand}}</strong><br>
                        <label>Código SAP:</label> <strong>{{version.codigo_sap}}</strong><br>
                        <label>Modelo:</label> <strong>{{version.model}}</strong><br>
                        <div v-if="version.status==1">
                          <label>Estado:</label> <strong>Activo</strong><br>
                        </div>
                        <div v-else>
                          <label>Estado:</label> <strong>Inactivo</strong><br>
                        </div>
                      <label>Creado en:</label> <strong>{{version.created_at}}</strong><br>
                      </b-col>
                    </b-row>
                <hr class="my-4">
                <b-btn variant="success" @click.stop="editversion(version._id)">Editar</b-btn>
                <b-btn variant="danger" @click.stop="deleteversion(version._id)">Eliminar</b-btn>
              </div>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from 'axios'
import Header from './Header'
import Menu from './Menu'
export default {
  name: 'ShowVersion',
  components:{
    Header,
    Menu
  },
  data () {
    return {
      version: []
    }
  },
  created () {
    if(localStorage.getItem('role')=="Administrador"){
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`/version/` + this.$route.params.id)
      .then(response => {
        this.version = response.data
        document.title = "Administración Derco - Version " + response.data.name
      })
      .catch(e => {
        this.errors.push(e)
      })
    }else{
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    editversion (versionid) {
      this.$router.push({
        name: 'EditVersion',
        params: { id: versionid }
      })
    },
    deleteversion (versionid) {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.delete('/version/' + versionid)
      .then((result) => {
        this.$router.push({
          name: 'VersionesByModel',
          params: { brand: this.version.brand }
        })
      })
      .catch(e => {
        this.errors.push(e)
      })
    },
    logout () {
      localStorage.removeItem('jwtToken')
      this.$router.push({
        name: 'Login'
      })
    }
  }
}
</script>

<style>
  .jumbotron {
    padding: 2rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/ShowVersion.vue